export default "__VITE_ASSET__DcWgtmoC__"